import React, {Component} from 'react';
import ClientPageBackButton from "../ClientPageBackButton";
import ScrollToComponent from "../ScrollToComponent";
import dokNaslovna from '../../images/dok-first.jpg';

var dokNaslovnaImg = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    height: "100vh",
    backgroundImage: `url(${dokNaslovna})`
};
export default class DobraOvsenaKasa extends Component {
    constructor(props) {
        super(props);
    }

    scrollNodes = [
		'#section1',
		'#section2',
		'#section3',
		'#section4',
		'#section5',
		'#section6',
		'#section7'
	];

    render() {
        return (
            <main className="smart-page">
                <ClientPageBackButton parentThis={this} currentSlideGroup={1} />
                <ScrollToComponent scrollNodes={this.scrollNodes}/>

                <div className="main-image-page" style={dokNaslovnaImg}>
                </div>
                <section id="section1" className="image-full position-image-zb">
                    <img src="/img/dos-site.jpg" alt="dobra-ovsena-kasa smart agency"/>
                </section>
                <section className="white-back dok">
                    <div className="relative clearfix div-set">
                        <div className="container-top-class">
                            <div id="section2" className="text-dok">
                                <p className="first-text">DOBRA STRANA PROMOCIJE</p>
                                <ul className="t-brown text top-padding margin-bottom-0">
                                    <li>I najmoćnija. To su svakako – mediji.</li>
                                    <li>Smart tim osmišljava i kreira sve medijske nastupe brenda Dobra ovsena kaša.
                                        Brinemo o njihovom imidžu na društvenim mrežama, na web-u, na radiju,
                                        televiziji.
                                    </li>
                                    <li>Od ideje, preko scenarija, vizuelnog i sadržajnog uobličavanja medijskih poruka,
                                        do media planiranja i media buyinga – Smart rešenja su uvek dobra odluka!
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="container-bottom-class bottom-image">
                            <img src="/img/dos-ekipa.jpg" alt="dobra-ovsena-kasa smart agency"/>
                        </div>
                    </div>
                </section>
                <section id="section3" className="image-full position-image-zb">
					<img src="/img/dok-ekran.jpg" alt="dobra-ovsena-kasa smart agency"/>
				</section>

				<section id="section4" className="image-full position-image-zb">
					<img src="/img/dos-femina1.jpg" alt="dobra-ovsena-kasa smart agency"/>
				</section>

                <section id="section5" className="white-back">
                    <div className="container-top-class">
                        <div className="image-full relative xs-480">
                            <div className="bottom-content-full">
                                <img className="white-back-img-first" src="/img/DoK_6_t_left.png" alt="dobra-ovsena-kasa smart agency"/>
                                <div className="absolute-text-dok">
                                    <div id="section6" className="left-content-item">
                                        <div className="text-content-left">
                                            <p className="first-text">BRAND AS A STAR</p>
                                            <p className="t-brown text top-padding margin-bottom-0">When at a public event, followed by the media and the general public, the brand is talked and discussed, when the brand inspires new ideas and goals, when all brands are branded ... then that brand is the star of the event! We are proud of all our stars.</p>
                                        </div>
                                        <img className="white-back-img-second" src="/img/DoK_6_m_right.png" alt="dobra-ovsena-kasa smart agency"/>
                                    </div>
                                    <div id="section7" className="right-content-item">
                                        <img className="white-back-img-third" src="/img/DoK_6_bt_left.png" alt="dobra-ovsena-kasa smart agency"/>
                                    </div>
                                </div>
                            </div>
                            <img className="md-480" src="/img/dok_6.jpg" alt="dobra-ovsena-kasa smart agency"/>
                        </div>
                    </div>
                </section>
            </main>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/English/DobraOvsenaKasaEnglishPage.js